<template>
  <div class="user_container">
    <div class="headerWrapper">

      <div class="keyword">
        <el-input v-model="keyword" placeholder="请输入关键词" @input="changeKeyword" clearable />
      </div>
      <div class="keyword">
        <!-- <el-input v-model="showFinishDate" placeholder="请输入选择日期" clearable @focus="changeShowDateTime"
          @change="changeKeyword" suffix-icon="el-icon-date" readonly/> -->
        <el-input v-model="showFinishDate" placeholder="请选择日期" :readonly="true" @click.native="changeShowDateTime">
          <i class="el-icon-circle-close el-input__icon" slot="suffix" v-show="showFinishDate" @click="clearableContent">
          </i>
        </el-input>
      </div>
    </div>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker v-model="finishDate" type="date" title="选择年月日" @confirm="comfirmEnd" @cancel="showDate = false"
        :min-date="minDate" />
    </van-popup>
    <div class="driverContainer">

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="driverItems" v-for="(item, index) in list" :key="index">
          <div class="itemsContent">
            <div @click="useCarDetail(item)">
              <div class="itemsUser">
                <div class="userTitle">{{ item.applyTitle }}</div>
                <div class="tabsList">
                  <div class="tabBtn colorYellow">
                    <span class="btn"> {{
                      useTypeList[item.useType - 1]
                    }}</span>
                  </div>
                  <div class="tabBtn colorGreen">
                    <span class="btn">已完成</span>
                  </div>
                </div>
              </div>
              <div class="itemsPlace">
                <div class="allotPlaceItems">
                  <div class="place">{{ item.airportName }}</div>
                </div>
                <div class="line">
                  <img src="@/assets/car/placeArrows.png" alt="" />
                </div>
                <div class="allotPlaceItems1">
                  <div class="place" v-for="(i, int) in item.addressInfoList" :key="int">{{ i.useLocation }}</div>
                </div>
              </div>
              <div class="itemsInfo">
                <div class="info">人数：{{ item.useNumber }}</div>
              </div>
              <div class="itemsInfo">
                <div class="info">
                  用车时间：<span style="font-size: 13px">{{
                    (item.departTime ? item.departTime : item.useSaterTime) +
                    " - " +
                    (item.comebackTime ? item.comebackTime : item.useEndTime)
                  }}</span>
                </div>
              </div>
              <div class="itemsInfo">
                <div class="info">用车里程：{{ item.realityMileage }}km</div>
              </div>
              <div class="itemsInfo">
                <div class="info">费用：{{ item.totalCost }}元</div>
              </div>
              <div class="itemsHeader">
                <div class="headerContent">
                  <img class="userName" :src="item.icon" alt="" />
                  <span>{{ item.driverName }}</span>
                </div>
                <div class="headerContent">
                  <img class="car" src="@/assets/car/carAllot.png" alt="" />
                  <span class="carTitle">{{ item.carBrand }}</span>
                </div>
              </div>
              <div class="splitLine"></div>
            </div>
            <div class="itemsBtn">
              <van-button type="default" size="small" @click="comfirmOff(item)">修改</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car";
import moment from "moment";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "alreadyFinish",
  props: {
    active: {
      default:null,
    }
  },
  data() {
    return {
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      list: [],
      useTypeList: ["客户接待", "接机", '送机', "供应商考察", "其他"],
      finishDate: new Date(),
      showDate: false,
      showFinishDate: null,
      keyword: '',
      minDate: new Date(2000, 1, 1),
    };
  },
  mounted() {

  },
  activated() {
    this.showDate = false;
  },
  methods: {
    // 搜索 关键词
    changeKeyword() {
      this.page=1
      this.queryUseCarAllot();
    },
    //显示日期选择器
    changeShowDateTime() {
      this.showDate = true;
    },
    //关闭时间选择
    clearableContent(event) {
      event.stopPropagation();
      this.showFinishDate = null;
      this.page=1
      this.queryUseCarAllot();
      this.showDate = false;

    },
    // 确定 时间选择
    comfirmEnd(value) {
      this.showFinishDate = moment(value).format('YYYY-MM-DD');
      this.showDate = false;
      this.page=1
      this.queryUseCarAllot();
    },
    // 初始化获取列表
    onLoad() {
      this.queryUseCarAllot();
    },
    // 获取已完成列表
    queryUseCarAllot() {
      const json = {
        applyState: 5,
        page: this.page,
        pageSize: this.pageSize,
        search: this.keyword,
        startTime: this.showFinishDate,
        zoneId: localStorage.getItem('cityId')
      };
      apis.queryUseCarAllotList(json).then(res => {
        this.totalAll = res.data.total;
        this.finished = false;
        // 判断分页，下滑刷新数据
        if (this.page === 1) {
          this.list = res.data.list;
        } else {
          this.list = this.list.concat(res.data.list);
        }
        if (this.list.length < this.totalAll) {
          this.page = this.page + 1;
        } else {
          this.finished = true;
        }
        this.loading = false;

        // 将时间戳转换为日期格式
        this.list = this.list.map(item => {
          item.checked = false;
          item.useSaterTime = moment(item.useSaterTime).format(
            "YYYY-MM-DD HH:mm"
          );
          item.useEndTime = moment(item.useEndTime).format("YYYY-MM-DD HH:mm");
          if (item.comebackTime) {
            item.comebackTime = moment(item.comebackTime).format(
              "YYYY-MM-DD HH:mm"
            );
          }
          if (item.departTime) {
            item.departTime = moment(item.departTime).format(
              "YYYY-MM-DD HH:mm"
            );
          }
          return item;
        });
      });
    },
    //跳转费用详情
    comfirmOff(item) {
      localStorage.setItem('active',this.active)
      this.$router.push(
        `/car/facility/useCarApply/carCostDetail?applyNumber=${item.applyNumber}`
      );
    },
    //跳转用车申请详情
    useCarDetail(item) {
      localStorage.setItem('active',this.active)
      this.$router.push(
        `/car/facility/alreadyAllotDetail?applyNumber=${item.applyNumber}&disabled=${true}`
      );
    },
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .driverContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .driverContainer {
    width: 276px * $zoom;
  }
}

.user_container {
  font-size: 16px * $zoom;
  display: flex;
  flex-direction: column;

  .headerWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px 20px 30px;
    background-color: #fff;

    .keyword {
      margin: 0 10px;

      ::v-deep .el-input__inner {
        background-color: #f7f9fa;
        border-radius: 30px;
        border: 0;
        padding: 35px 25px;
      }

      // ::v-deep .van-cell__value {
      //   background-color: #f7f9fa;
      // }
    }

    .time {
      flex: 1;
      display: flex;
      justify-content: center;

      .timeItem {
        font-size: 29px;

        ::v-deep .van-icon {
          margin-left: 20px;
        }
      }
    }
  }

  .driverContainer {
    padding: 30px;
    height: calc(100vh - 110px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .driverItems {
      margin-bottom: 20px;
      background-color: #fff;

      .itemsHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headerContent {
          font-size: 27px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
          display: flex;
          align-items: center;

          .userName {
            width: 53px;
            height: 53px;
            border-radius: 50%;
            margin-right: 11px;
          }

          .car {
            width: 36px;
            height: 27px;
            margin-right: 11px;
          }

          .carTitle {
            font-weight: bold;
          }
        }
      }

      .itemsContent {
        padding: 0 20px 25px 20px;

        .itemsUser {
          display: flex;
          flex-direction: column;
          margin: 0 0 4vh 0;

          .userTitle {
            font-size: 27px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #282b32;
            margin-right: 20px;
            padding-top: 36px;
          }

          .tabsList {
            display: flex;

            .tabBtn {
              min-width: 106px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-radius: 6px;
              padding: 0 10px;
              margin-top: 36px;
              margin-right: 20px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .colorYellow {
              background-color: #fff3e8;
              color: #ff8e20;
            }

            .colorBlue {
              background-color: #e9f1fc;
              color: #2c76e3;
            }

            .colorGreen {
              background-color: #edf5f2;
              color: #4ea27c;
            }
          }
        }

        .itemsPlace {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 24px;

          .line {
            width: 50px;
            height: 7px;
            display: flex;
            align-items: center;
            margin: 0 18px;

            img {
              width: 50px;
              height: 7px;
            }
          }

          .allotPlaceItems {
            min-width: 23%;
            max-width: 29%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }

          .allotPlaceItems1 {
            min-width: 23%;
            max-width: 87%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }
        }

        .itemsInfo {
          margin: 2vh 0;
          font-size: 24px;
          color: #a3a2a0;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
        }

        .splitLine {
          width: 100%;
          height: 1px;
          border: 1px solid #f1f1f1;
          margin: 37px 0;
        }

        .itemsBtn {
          text-align: right;

          ::v-deep(.van-button--small) {
            border-radius: 10px;
            height: 50px;
            padding: 0 30px;
            background-color: #4ea27c;
            font-size: 27px;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep(.van-form) {
    .van-cell {
      border: 1px solid #cccccc;
      margin-bottom: 20px;
    }
  }
}
</style>
